import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { SharedModule } from './shared/shared.module';
import { AuthModule, OidcSecurityService, OpenIDImplicitFlowConfiguration, OidcConfigService, AuthWellKnownEndpoints } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationService } from './core/authentication/authentication.service';
import { AuthorizationGuard } from './core/guards/authentication.guard';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateMomentAdapter } from './core/services/ngb-date-moment-adaptater';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { createTranslateLoader } from './core/translation/loader-factory';
import { ToastrModule } from 'ngx-toastr';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ShipperApi } from './core/http/shipper.api.service';
import { NgbDateMomentParserFormatter } from './core/services/ngb-date-moment-parser-formatter';
import { CommonApi } from './core/http/common.api.service';
import { SignalRService } from './core/services/signal-r';
import { HeaderService } from './layout/header/header.service';
import { PermissionGuard } from './core/guards/permission.guard';
import { FirstLoadGuard } from './core/guards/first-load.guard';
import { HomeComponent } from './modules/landing-page/home/home.component';
// import { ContactComponent } from './modules/landing-page/contact/contact.component';
import { HeaderLandingPageComponent } from './layout/header-landing-page/header-landing-page.component';
import { FooterLandingPageComponent } from './layout/footer-landing-page/footer-landing-page.component';
// import { ForBuyerComponent } from './modules/landing-page/for-buyer/for-buyer.component';
// import { ForCarrierComponent } from './modules/landing-page/for-carrier/for-carrier.component';
// import { AboutComponent } from './modules/landing-page/about/about.component';
import { Landinguard } from './core/guards/landing.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { TermsOfUseComponent } from './modules/landing-page/terms-of-use/terms-of-use.component';
// import { PrivacyPolicyComponent } from './modules/landing-page/privacy-policy/privacy-policy.component';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { isPlatformBrowser } from '@angular/common';
import { SignUpComponent } from './modules/sign-up/sign-up.component';
import { LoginComponent} from './modules/login/login.component';
import { LoaderService } from './shared/components/loader/loader.service';
export function loadConfig(oidcConfigService: OidcConfigService) {
  console.log('APP_INITIALIZER STARTING');
  return () => oidcConfigService.load_using_custom_stsServer(`https://${environment.aadConfig.tenant}.b2clogin.com/${environment.aadConfig.tenant}.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=${environment.aadConfig.signin_signup_policy}`);
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    // ContactComponent,
    HeaderLandingPageComponent,
    FooterLandingPageComponent,
    // ForBuyerComponent,
    // ForCarrierComponent,
    // AboutComponent,
    // TermsOfUseComponent,
    // PrivacyPolicyComponent
    SignUpComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    HttpClientModule,
    AuthModule.forRoot(),
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient, PLATFORM_ID]
      }
    }),
    NgSlimScrollModule
  ],
  providers: [
    AuthenticationService,
    OidcConfigService,
    AuthorizationGuard,
    PermissionGuard,
    FirstLoadGuard,
    Landinguard,
    ShipperApi,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfig,
      deps: [OidcConfigService],
      multi: true
    },
    {
      provide: NgbDateAdapter,
      useClass: NgbDateMomentAdapter
    },
    {
      provide: NgbDateParserFormatter,
      useClass: NgbDateMomentParserFormatter
    },
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
    },
    SignalRService,
    HeaderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private oidcConfigService: OidcConfigService,
    @Inject(PLATFORM_ID) private platformId,
    private translate: TranslateService
  ) {
    this.translate.use('en');
    if (isPlatformBrowser(platformId)) {
      this.oidcConfigService.onConfigurationLoaded.subscribe(() => {
        const openIDImplicitFlowConfiguration = new OpenIDImplicitFlowConfiguration();
        openIDImplicitFlowConfiguration.stsServer = environment.aadConfig.stsServer;
        openIDImplicitFlowConfiguration.redirect_url = environment.aadConfig.redirect_url;
        openIDImplicitFlowConfiguration.client_id = environment.aadConfig.client_id;
        openIDImplicitFlowConfiguration.response_type = environment.aadConfig.response_type;
        openIDImplicitFlowConfiguration.start_checksession = false;
        openIDImplicitFlowConfiguration.silent_renew = false;
        openIDImplicitFlowConfiguration.scope = environment.aadConfig.scope;
        openIDImplicitFlowConfiguration.post_logout_redirect_uri = environment.aadConfig.post_logout_redirect_uri;
        openIDImplicitFlowConfiguration.post_login_route = environment.aadConfig.post_login_route;
        openIDImplicitFlowConfiguration.forbidden_route = environment.aadConfig.forbidden_route;
        openIDImplicitFlowConfiguration.unauthorized_route = environment.aadConfig.unauthorized_route;
        openIDImplicitFlowConfiguration.auto_userinfo = false;
        openIDImplicitFlowConfiguration.log_console_warning_active = true;
        openIDImplicitFlowConfiguration.log_console_debug_active = false; //!environment.production;
        openIDImplicitFlowConfiguration.max_id_token_iat_offset_allowed_in_seconds = 3600;
        openIDImplicitFlowConfiguration.storage = localStorage;
        const authWellKnownEndpoints = new AuthWellKnownEndpoints();
        authWellKnownEndpoints.setWellKnownEndpoints(this.oidcConfigService.wellKnownEndpoints);
        this.oidcSecurityService.setupModule(openIDImplicitFlowConfiguration, authWellKnownEndpoints);
      });
    }
    console.log('APP STARTING');
  }
}
